const nextSelector = '[next-step]';
const prevSelector = '[previous-step]';
const stepSelector = '[form-part]';
const activeAttr = 'data-current-step';

if (document.querySelector(nextSelector)) {
  
  const switchToStep = (currentStep, targetStep) => {
    currentStep?.setAttribute(activeAttr, false);
    targetStep?.setAttribute(activeAttr, true);
  };

  const findSiblingStep = (step, direction) => {
    let sibling = direction === 'next' ? step?.nextElementSibling : step?.previousElementSibling;
    while (sibling && !sibling.hasAttribute('form-part')) {
      sibling = direction === 'next' ? sibling.nextElementSibling : sibling.previousElementSibling;
    }
    return sibling;
  };

  const validateStep = step => {
    const inputs = step.querySelectorAll('input, select, textarea');
    for (const input of inputs) {
      if (!input.checkValidity()) {
        input.reportValidity();
        return false;
      }
    }
    return true;
  };

  const handleNext = e => {
    const currentStep = e.target.closest(stepSelector);
    const nextStep = findSiblingStep(currentStep, 'next');
    if (nextStep && validateStep(currentStep)) {
      switchToStep(currentStep, nextStep);
    }
  };

  const handlePrev = e => {
    const currentStep = e.target.closest(stepSelector);
    const prevStep = findSiblingStep(currentStep, 'prev');
    if (prevStep) {
      switchToStep(currentStep, prevStep);
    }
  };

  document.querySelectorAll(nextSelector).forEach(btn =>
    btn.addEventListener('click', handleNext)
  );

  document.querySelectorAll(prevSelector).forEach(btn =>
    btn.addEventListener('click', handlePrev)
  );
}
